import { GlobalCtasLPsExperiment } from '@mc/promos'
import { PageSource } from '@mc/track-event'

import CTA from 'components/CTA'
import { PricingText } from 'components/PricingText'
import { useRevampedPricingCopyExp } from 'experiments/pen-4819_v1_revamped_pricing_copy'

interface HeroCTAProps {
  fullWidth?: boolean
  headline: string
}

export const HeroCTA = ({ fullWidth = false, headline }: HeroCTAProps) => {
  const { isPen4819Variant } = useRevampedPricingCopyExp()

  return (
    <>
      <div className='d-block d-lg-none'>
        <div className='row justify-content-center mc-text--center align-items-start'>
          <div className='col-12' style={{ maxWidth: '400px' }}>
            <div className='mc-mb-3'>
              <GlobalCtasLPsExperiment
                variant={(giftButton: React.ReactNode) => (
                  <div className='d-flex flex-gap-3'>
                    {giftButton}
                    <CTA
                      fullWidth
                      trackProps={{
                        category: headline,
                        content_type: 'product',
                        location: 'hero',
                        page_source: PageSource.SUBCATEGORY,
                      }}
                    />
                  </div>
                )}
              >
                <CTA
                  fullWidth={fullWidth}
                  style={{ maxWidth: '380px' }}
                  className='mc-px-9'
                  trackProps={{
                    category: headline,
                    content_type: 'product',
                    location: 'hero',
                    page_source: PageSource.SUBCATEGORY,
                  }}
                />
              </GlobalCtasLPsExperiment>
            </div>
          </div>
          <div className={`mc-mt-1 ${isPen4819Variant ? 'col-10' : 'col-9'}`}>
            <p className='mc-text-small'>
              <PricingText
                translationKey='long'
                className='mc-opacity--hinted'
                useRevampedPricingCopy
              />
            </p>
          </div>
        </div>
      </div>
      <div className='d-none d-lg-block'>
        <GlobalCtasLPsExperiment
          variant={(giftButton: React.ReactNode) => (
            <div className='col-7'>
              <div className='d-flex flex-gap-3 mc-mb-3'>
                {giftButton}
                <CTA
                  fullWidth
                  trackProps={{
                    category: headline,
                    content_type: 'product',
                    location: 'hero',
                    page_source: PageSource.SUBCATEGORY,
                  }}
                />
              </div>
              <PricingText
                translationKey='long'
                className='mc-text-small mc-opacity--hinted'
                useRevampedPricingCopy
              />
            </div>
          )}
        >
          <div className='row justify-content-start mc-text--left align-items-start'>
            <div className='col-auto'>
              <CTA
                fullWidth
                className='mc-mb-3 mc-px-9'
                trackProps={{
                  category: headline,
                  content_type: 'product',
                  location: 'hero',
                  page_source: PageSource.SUBCATEGORY,
                }}
              />
            </div>
            <PricingText
              translationKey='long'
              className={`mc-text-small mc-opacity--hinted${isPen4819Variant ? ' col-6' : ' col-5'}`}
              useRevampedPricingCopy
            />
          </div>
        </GlobalCtasLPsExperiment>
      </div>
    </>
  )
}
